<template>
    <transition name="modal-fade">
        <div
            class="modal"
            v-if="isVisible"
        >
            <div
                class="modal-content"
                :class="modalSizeClass"
                :style="customWidthStyle"
            >
                <div
                    class="header"
                >
                    <span
                        class="close"
                        @click="closeModal"
                    >&times;
                    </span>

                    <!-- Título dinâmico do modal -->
                    <h5>{{ title }}</h5>
                </div>

                <div class="content">
                    <!-- Conteúdo personalizado usando slots -->
                    <slot name="content"></slot>
                </div>

                <div class="modal-actions footer">
                    <slot name="actions">
                        <button
                            class="btn btn-cancel"
                            @click="closeModal"
                        >Fechar
                        </button>
                    </slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'BaseModal', // Nome do componente
    props: {
        isVisible: { // Visibilidade do modal
            type: Boolean,
            default: false
        },
        title: { // Título do modal
            type: String,
            default: 'Modal'
        },
        size: { // Tamanho do modal (sm, md, lg, xl)
            type: String,
            default: 'md',
            validator: function(value) {
                // O valor deve ser um dos tamanhos predefinidos
                return ['sm', 'md', 'lg', 'xl'].indexOf(value) !== -1;
            }
        },
        width: { // Largura customizada (para compatibilidade ou valores não padrão)
            type: [String, Number],
            default: null
        }
    },
    computed: {
        // Define a classe CSS de acordo com o tamanho escolhido
        modalSizeClass() {
            if (this.width) {
                // Se width está definido, não aplica classe de tamanho
                return null;
            }

            switch(this.size) {
                case 'sm': return 'modal-sm';
                case 'lg': return 'modal-lg';
                case 'xl': return 'modal-xl';
                default: return 'modal-md'; // 'md' é o tamanho padrão
            }
        },
        // Aplica largura customizada se fornecida
        customWidthStyle() {
            if (this.width) {
                // Converte número para string com 'px' ou mantém a string original
                const widthValue = typeof this.width === 'number' ? `${this.width}px` : this.width;
                return {
                    width: widthValue,
                    maxWidth: '95vw' // Limite para responsividade
                };
            }
            // Caso contrário, retorna um objeto vazio
            return {};
        }
    },
    methods: {
        closeModal() { // Método para fechar o modal
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: #fff;
    border-radius: 5px;
    position: relative;
    width: 100%;
    max-width: 95vw;
}

/* Tamanhos padrão do Bootstrap */
.modal-sm {
    max-width: 300px;
}

.modal-md {
    max-width: 500px;
}

.modal-lg {
    max-width: 800px;
}

.modal-xl {
    max-width: 1140px;
}

.modal-content .header, .modal-content .footer {
    padding: 10px 20px;
    font-size: 12px;
    border-bottom: 1px solid #eee;
}

.modal-content .footer {
    border-bottom: none;
    border-top: 1px solid #eee;
}

.modal-content .content {
    padding: 20px;
    overflow-y: auto;
    max-height: calc(100vh - 200px);
}

.close {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 24px;
    cursor: pointer;
}

.modal-actions {
    margin-top: 0;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.btn {
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    border: none;
}

.btn-cancel {
    background-color: #f1f1f1;
}

.btn-edit {
    background-color: #4CAF50;
    color: white;
    text-decoration: none;
    display: inline-block;
}

/* Animações */
.modal-fade-enter-active, .modal-fade-leave-active {
    transition: opacity 0.3s;
}

.modal-fade-enter, .modal-fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Base/BaseModal.vue